const translations = {
  // Navbar
  "nav.all-deals": "Offers",
  "nav.my-card": "Activity",
  "nav.my-account": "My Account",
  "nav.my-profile": "Profile",
  "nav.refer": "Refer & Earn",
  "nav.search": "Search offers",
  "nav.all-offers": "See all offers",
  "nav.logout": "Logout",
  "nav.videos": "Videos",
};

export default translations;